// Default host for the event tracker Host field. The assigned staff member wins when the
// booking has exactly one and they are in the selectable list; otherwise the signed in
// user when selectable; otherwise null (no selection, the server records the submitter).
export function defaultHostId(assignedStaff, staffMembers, currentUserId) {
  const selectable = new Set((staffMembers || []).map(s => Number(s.id)))
  const assigned = Array.isArray(assignedStaff) ? assignedStaff : []
  if (assigned.length === 1 && selectable.has(Number(assigned[0].id))) {
    return Number(assigned[0].id)
  }
  if (currentUserId !== null && currentUserId !== undefined && selectable.has(Number(currentUserId))) {
    return Number(currentUserId)
  }
  return null
}
